import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Chip
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const procurementTimeline = [
  { no: 1, activity: "Announcement", start: "February 5, 2026 16:00", end: "February 20, 2026 11:59" },
  { no: 2, activity: "Submission of EOI", start: "February 5, 2026 16:01", end: "February 20, 2026 11:59" },
  { no: 3, activity: "Shortlist Appointment", start: "February 20, 2026 12:00", end: "May 8, 2026 23:59" },
  { no: 4, activity: "Shortlist Announcement and Issuance of RFP", start: "May 11, 2026 00:00", end: "June 29, 2026 23:59" },
  { no: 5, activity: "Clarification Request Period", start: "May 13, 2026 00:00", end: "June 18, 2026 09:00" },
  { no: 6, activity: "Submission of Technical and Financial Proposals", start: "May 11, 2026 00:00", end: "June 29, 2026 11:59" },
  { no: 7, activity: "Opening of Tech Proposal", start: "June 29, 2026 13:00", end: "June 29, 2026 23:59" },
  { no: 8, activity: "Evaluation of Technical Proposals", start: "June 29, 2026 13:00", end: "July 17, 2026 23:59" },
  { no: 9, activity: "Technical Rank Announcement", start: "July 29, 2026 00:00", end: "July 29, 2026 23:59" },
  { no: 10, activity: "Opening of Financial Proposals", start: "August 13, 2026 10:00", end: "August 13, 2026 13:00" },
  { no: 11, activity: "Evaluation of Financial Proposals", start: "August 13, 2026 13:01", end: "August 20, 2026 15:59" },
  { no: 12, activity: "Combined Evaluation", start: "August 20, 2026 00:00", end: "August 20, 2026 15:59" },
  { no: 13, activity: "Final Ranking", start: "August 20, 2026 16:00", end: "August 20, 2026 23:59" },
  { no: 14, activity: "Contract Negotiation", start: "August 21, 2026 00:00", end: "August 24, 2026 23:59" },
  { no: 15, activity: "Notification of Intention of Award", start: "September 8, 2026 00:00", end: "September 8, 2026 23:59" },
  { no: 16, activity: "Standstill Period", start: "September 9, 2026 00:00", end: "September 22, 2026 23:59" },
  { no: 17, activity: "Notification of Award", start: "September 23, 2026 00:00", end: "September 23, 2026 23:59" },
  { no: 18, activity: "Contract Signing", start: "September 24, 2026 00:00", end: "October 2, 2026 23:59" },
];

function GeoClimate() {
  const url_list = Config.api_domain + "/geoclimate/active/";
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(true); // modal langsung terbuka

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  function getRows() {
    if (list && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/geoclimate/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        {/* === POPUP NOTICE === */}
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle sx={{ backgroundColor: "#f1f8e9", borderBottom: "2px solid #1b5e20", pb: 1.5 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Chip
                label="GeoClimate"
                size="small"
                sx={{
                  backgroundColor: "rgba(27, 94, 32, 0.1)",
                  color: "#1b5e20",
                  fontWeight: 700,
                  border: "1px solid #1b5e20",
                  fontSize: "0.75rem",
                }}
              />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#2e2e2e" }}>
                Opening of Tech Proposal – Zoom Meeting
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent dividers sx={{ pt: 2 }}>
            <Typography paragraph sx={{ fontSize: "0.9rem", color: "#333" }}>
              ILASP PHLN invites you to join a scheduled Zoom meeting.
            </Typography>

            {[
              { label: "Topic", value: "Opening of Tech Proposal: Geospatial Data Utilization Platform for Climate Action" },
              { label: "Time", value: "June 29, 2026, 01:00 PM Jakarta" },
              { label: "Meeting ID", value: "967 7535 6923" },
              { label: "Passcode", value: "Pq?q$L3T" },
            ].map(({ label, value }) => (
              <Box key={label} display="flex" gap={1} mb={0.75} alignItems="flex-start">
                <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#1b5e20", minWidth: "110px", flexShrink: 0 }}>
                  {label}:
                </Typography>
                <Typography sx={{ fontSize: "0.85rem", color: "#333" }}>{value}</Typography>
              </Box>
            ))}

            <Box display="flex" gap={1} mb={0.75} alignItems="flex-start">
              <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#1b5e20", minWidth: "110px", flexShrink: 0 }}>
                Join Meeting:
              </Typography>
              <a
                href="https://big-go-id.zoom.us/j/96775356923?pwd=kOaOJjJeuYrjoZnvvSabUrIgns2GLE.1"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1b5e20", fontSize: "0.85rem", wordBreak: "break-all" }}
              >
                https://big-go-id.zoom.us/j/96775356923?pwd=kOaOJjJeuYrjoZnvvSabUrIgns2GLE.1
              </a>
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 1.5 }}>
            <Button
              onClick={() => setOpen(false)}
              variant="contained"
              sx={{ backgroundColor: "#1b5e20", "&:hover": { backgroundColor: "#145214" }, textTransform: "none", fontWeight: 600, px: 3 }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* === CONTENT === */}
        <h2>Geospatial Data Utilization Platform For Climate Action</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          As part of the implementation of the Integrated Land Administration and Spatial Planning (ILASP) Project, the Geospatial Information Agency (BIG) is seeking a consulting firm (or consortium) to provide data and platform development consultation services. The objective is to develop platform allowing geospatial data and information utilization for climate action and spatial planning. This assignment, scheduled for the period 2026–2029, will involve developing platform and specification, integrating geospatial data, as well as analyse thematic data and modelling. The selected consultant will act on behalf of BIG, work in close coordination with the Directorate of Atlas and Geospatial Information Utilization, and submit reports and documentation that will serve as the basis for project-related payment processes.
        </p>

        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>
        <h3>Procurement Timeline</h3>
<TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table sx={{ minWidth: 500 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
  {procurementTimeline.map((row) => (
    <StyledTableRow key={row.no}>
      <StyledTableCell>{row.no}</StyledTableCell>
      <StyledTableCell>{row.activity}</StyledTableCell>
      <StyledTableCell>{row.start} (GMT+7)</StyledTableCell>
      <StyledTableCell>{row.end} (GMT+7)</StyledTableCell>
    </StyledTableRow>
  ))}
</TableBody>
  </Table>
</TableContainer>

<Typography variant="caption" sx={{ mt: 1, display: "block" }}>
  All schedules are based on Jakarta time (GMT +7)
</Typography>
<p style={{ textAlign: "justify" }}>
  The package will be processed through SPSE ICB at the link:{" "}
  <a
    href="https://spseicb.lkpp.go.id/spseicb/lelang/view/2630999"
    target="_blank"
    rel="noopener noreferrer"
  >
    https://spseicb.lkpp.go.id/spseicb/lelang/view/2630999
  </a>

</p>
      </Container>
    </div>
  );
}

export default GeoClimate;
